export const VND_EXCEL_MIME_TYPE = 'application/vnd.ms-excel'
export const CSV_MIME_TYPE = 'text/csv'

export const MIME_TYPES_EXCEL = [
  VND_EXCEL_MIME_TYPE,
  'application/msexcel',
  'application/x-msexcel',
  'application/x-ms-excel',
  'application/x-excel',
  'application/x-dos_ms_excel',
  'application/xls',
  'application/x-xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
]

export const MIME_TYPES_CSV = [
  CSV_MIME_TYPE
]

export const MIME_TYPES = [
  ...MIME_TYPES_CSV,
  ...MIME_TYPES_EXCEL
]
